import {defineMessages} from 'react-intl';

export default defineMessages({
  languageHeader: {
    defaultMessage: 'Language:',
    id: 'Footer.FooterLanguageSwitch.Language.LanguageHeader',
  },
});
